import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC9qoEw0sng8-QqrlDQIDe1ARukILDPgvE",
  authDomain: "nutu-f7e72.firebaseapp.com",
  projectId: "nutu-f7e72",
  storageBucket: "nutu-f7e72.firebasestorage.app",
  messagingSenderId: "138298400800",
  appId: "1:138298400800:web:fe8b7a388119186c399c45"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);